import { LucideIcon } from 'lucide-react';

export default function EmptyState({
  icon: Icon,
  title,
  subtitle,
}: {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
}) {
  return (
    <div className="text-center py-10">
      <div className="w-14 h-14 rounded-full bg-slate-100 grid place-items-center mx-auto mb-3">
        <Icon className="h-6 w-6 text-slate-400" />
      </div>
      <div className="font-semibold text-slate-900">{title}</div>
      {subtitle && <div className="text-sm text-slate-500 mt-1">{subtitle}</div>}
    </div>
  );
}
